import { render, staticRenderFns } from "./_MarketReportResult_analysisSummary.vue?vue&type=template&id=0f60cd84&scoped=true&"
import script from "./_MarketReportResult_analysisSummary.vue?vue&type=script&lang=js&"
export * from "./_MarketReportResult_analysisSummary.vue?vue&type=script&lang=js&"
import style0 from "./_MarketReportResult_analysisSummary.vue?vue&type=style&index=0&id=0f60cd84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60cd84",
  null
  
)

export default component.exports